import gql from "graphql-tag";

const MEMBERS_QUERY = gql`  
query Members($chapterId: String!){
    volunteers(chapterId: $chapterId) {
      LookupId
      Name
      StartDate
      EndDate
      Roles {
        GroupMemberRoleId
        Role
        RoleStartDate
        RoleEndDate
      }
      PrimaryContact
      GroupMemberDateRangeId
      GroupMemberId
      SystemRecordId
      GroupMembersSystemId
    }  
    volunteerRoles{
      ID
      RoleDescription
      Status
      Sequence
    }
  }
`;
export default MEMBERS_QUERY;